const home = {
  range: {
    eyebrow: 'Nuestros productos',
    heading: 'Conozca nuestra gama',
    features: [
      {
        title: 'Grados premium',
        description: 'Grados Continental y Hamburgo, quillings, recortes, aceite de canela, pimienta y nuez de areca.',
        linkText: 'Ver productos',
      },
      {
        title: 'Cómo elegir un grado',
        description: 'Qué grado conviene para menudeo, bebidas, panadería o industria, además de consejos de almacenamiento y cocina.',
        linkText: 'Encuentre su grado',
      },
      {
        title: 'Canela verdadera',
        description: 'Tradición, oficio y cómo distinguir la canela de Ceilán de la cassia: la historia de la canela auténtica.',
        linkText: 'Conozca la canela verdadera',
      },
    ],
  },

  about: {
    eyebrow: 'Sobre Spice Yield',
    title: 'Llevamos al mundo la bondad natural de las especias auténticas',
    intro: 'Somos una empresa familiar con raíces profundas en la franja costera del sur de Sri Lanka, donde cuidamos nuestras propias plantaciones de especias. Nuestro compromiso con la calidad, la sostenibilidad y el oficio tradicional nos ha convertido en un nombre de confianza en más de 50 países.',
    knownAs: {
      before: 'Conocida como "canela verdadera" o ',
      after: ', nuestra canela de Ceilán es apreciada por su sabor dulce y delicado y por un aroma incomparable que ha cautivado a civilizaciones durante más de cuatro milenios.',
    },
    link: 'Conozca nuestra historia',
    // Se muestra con el "30+" sobre la foto de la plantación
    badgeText: 'Años de experiencia',
  },

  why: {
    eyebrow: 'Por qué Spice Yield',
    title: 'Excelencia en cada rama',
    subtitle: 'Nuestro apego a las normas internacionales de calidad y nuestra pasión por los sabores auténticos nos han convertido en una marca de confianza en todo el mundo.',
    cards: [
      { title: 'Calidad garantizada', text: 'Cada lote se analiza y certifica para cumplir con las normas internacionales más exigentes.' },
      { title: 'Alcance global', text: 'Socio de confianza de empresas en más de 50 países de 6 continentes.' },
      { title: 'Integración vertical', text: 'De nuestras propias plantaciones hasta su puerta: control total de la calidad.' },
      { title: 'Abastecimiento sostenible', text: 'Comprometidos con prácticas éticas que protegen a las personas y al planeta.' },
    ],
  },

  stats: {
    eyebrow: 'Nuestro impacto',
    title: 'Spice Yield en cifras',
    items: [
      { number: '30+', label: 'Años de excelencia', suffix: 'Desde 1994' },
      { number: '50+', label: 'Países', suffix: 'Alcance global' },
      { number: '100%', label: 'Calidad garantizada', suffix: 'Cada lote analizado' },
      { number: '7', label: 'Grados de canela', suffix: 'De C5 a H3' },
    ],
  },

  cta: {
    eyebrow: 'Empecemos',
    title: '¿Busca un proveedor de canela de Ceilán auténtica?',
    text: 'Ya sea minorista, fabricante o distribuidor, le ofrecemos especias de primera calidad directamente desde Sri Lanka.',
    primary: 'Solicitar cotización',
    secondary: 'Ver productos',
    statText: 'Países confían en nosotros',
  },
};

export default home;
